import React from 'react';
import PrivateRoute from './PrivateRoute';
import { connect } from 'react-redux';
import { isTeacher } from '../../api/redux-bridge/session/selectors';
import { FILE_NOT_FOUND } from '../../api/redux-route/routes';
import PrivateContentRenderer from './PrivateContentRenderer';

class TeacherRoute extends React.Component {
  render() {
    return (
      <PrivateRoute
        path={this.props.path}
        exact={this.props.exact}
        render={routeProps => (
          <PrivateContentRenderer
            hasAccess={this.props.teacher}
            redirectTo={FILE_NOT_FOUND}
            render={this.props.render}
            component={this.props.component}
            innerProps={routeProps}
          />
        )}
      />
    );
  }
}

const mapStateToProps = state => ({
  teacher: isTeacher(state),
});

export default connect(mapStateToProps)(TeacherRoute);
